import { ApiResourceBaseClass as o } from "./baseApiCalls.js";
const i = "whatsapp/signup", s = "whatsapp/accounts";
class r extends o {
  /**
   * Imports a Whatsapp account.
   * To be called after successful embedded signup.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/whatsapp/signup`
   *
   * @param {number} [code] - The code generated by the embedded signup process.
   * @param {boolean} [need_partoo_number] - Whether a we should create a WhatsappPhoneNumber for the account, using a dedicated Partoo number.
   * @param {string | undefined} [userId] - Id of the meta user that imported the account.
   * @param {string | undefined} [brandId] - The business which will be associated to the WhatsappBusinessAccount.
   * @returns {Promise<WhatsappSuccessResponse>} A promise that resolves to a success payload.
   */
  signup = async (t, a, n, c) => {
    const { data: e } = await this.post(i, {
      code: t,
      meta_user_id: n,
      need_partoo_number: a,
      brand_id: c
    });
    return e;
  };
  /**
   * Fetches the number of WABA created, and the number of waba allowed for the Organization.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/whatsapp/accounts/count`
   *
   * @returns {Promise<WhatsappBusinessAccountsCount>} A promise that resolves to an object containing the number of WABAs.
   */
  getAccountsCount = async () => {
    const { data: t } = await this.get(`${s}/count`);
    return t;
  };
  /**
   * Lists WhatsappBusinessAccounts.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/whatsapp/accounts`
   *
   * @returns {Promise<WhatsappBusinessAccountsPage>} A promise that resolves to a paginated list of WABA.
   */
  getAccountsList = async () => {
    const { data: t } = await this.get(s);
    return t;
  };
}
export {
  r as WhatsappBusinessAccount
};
